import { createFileRoute } from "@tanstack/react-router";
import Portfolio from "@/pages/Portfolio";
import { industriesQuery, projectsLeanQuery, safePrefetch, type Industry } from "@/lib/publicQueries";
import { seoHead } from "@/lib/seo";
import { toSlug } from "@/lib/utils";

export const Route = createFileRoute("/portfolio/industry/$industry")({
  loader: async ({ context, params }) => {
    const [, industries] = await Promise.all([
      safePrefetch(context.queryClient, projectsLeanQuery({ publicOnly: true })),
      safePrefetch(context.queryClient, industriesQuery()),
    ]);
    const slug = params.industry.toLowerCase();
    const match = ((industries as Industry[] | undefined) || []).find((i) => toSlug(i.name) === slug);
    return { industryName: match?.name ?? null };
  },
  head: ({ loaderData, params }) => {
    const name = loaderData?.industryName ?? params.industry.replace(/-/g, " ");
    return seoHead({
      title: `${name}: Fotos & Videos | Clicks DMP`,
      description: `Referenzen aus ${name}: Fotografie und Videoproduktion von Clicks DMP in Mannheim und Rhein-Neckar.`,
      path: `/portfolio/industry/${params.industry.toLowerCase()}`,
    });
  },
  component: Portfolio,
});
